import { render, staticRenderFns } from "./AuthorizationManagement.vue?vue&type=template&id=5e3da81d&scoped=true&"
import script from "./AuthorizationManagement.vue?vue&type=script&lang=js&"
export * from "./AuthorizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationManagement.vue?vue&type=style&index=0&id=5e3da81d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3da81d",
  null
  
)

export default component.exports